// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import React from 'react';
import { useTranslation } from 'react-i18next';
import Styles from './footer.module.scss';
import { logPageAction } from 'src/lib/ApplicationInsights';
import URLS from './../../constants/urls';

export default function Footer() {
    const { t } = useTranslation();
    const footerLinks = [
        { name: t(`sitemap`), url: URLS.sitemap },
        { name: t(`contact_us`), url: URLS.contact_us },
        { name: t(`terms_of_use`), url: URLS.terms_of_use },
        { name: t(`trademarks`), url: URLS.trademarks },
        { name: t(`privacy_&_cookies`), url: URLS.privacy_and_cookies },
    ];

    function onClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        logPageAction(`Footer link clicked: ${event.currentTarget.innerText}`);
    }

    return (
        <footer className={Styles.footer}>
            <div className={Styles.linkContainer}>
                {
                    footerLinks.map(link => {
                        return (
                            <div onClick={onClick} className={Styles.link} key={link.name}>
                                <a className={Styles.linkText} href={link.url} target="_blank" >{link.name}</a>
                            </div>
                        );
                    })
                }
            </div>
        </footer>
    );
}